(function () {
  if (window.__bwxCw) return; window.__bwxCw = true;
  var RX = /'([^']+)'\s*$/;
  function baseOf(t) { t = String(t || '').trim(); var m = t.match(RX); return m ? t.slice(0, m.index).replace('--_', '').trim().toLowerCase() : ''; }
  function colourOf(t) { var m = String(t || '').trim().match(RX); return m ? m[1].trim() : t; }
  function cleanUrl(u) { return String(u || '').split('?')[0]; }
  function img(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
  function search(root, q, field) {
    var url = root + (root.slice(-1) === '/' ? '' : '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][fields]=' + field +
      '&resources[options][unavailable_products]=hide';
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (j) { return (j && j.resources && j.resources.results && j.resources.results.products) || []; })
      .catch(function () { return []; });
  }
  function init(el) {
    if (el.__bwx) return; el.__bwx = true;
    var key = el.getAttribute('data-key'), base = el.getAttribute('data-base'), vend = (el.getAttribute('data-vendor') || '').toUpperCase(), type = el.getAttribute('data-type') || '';
    var handle = el.getAttribute('data-handle'), root = el.getAttribute('data-root') || '/';
    var b = String(base || '').toLowerCase();
    function own(p) { return p && p.handle !== handle && p.available !== false && String(p.vendor || '').toUpperCase() === vend; }
    var run = key ? search(root, key, 'variants.sku').then(function (r) { return r.filter(own); }) : Promise.resolve([]);
    run.then(function (list) {
      if (key || !b) return list;
      return search(root, base, 'title').then(function (r) { return r.filter(function (p) { return own(p) && (!type || p.type === type) && baseOf(p.title) === b; }); });
    }).then(function (list) {
      /* only colourways that can be ordered in the visitor's market (sections/bwx-mkt) */
      var pre = root + (root.slice(-1) === '/' ? '' : '/');
      return Promise.all(list.map(function (p) {
        return fetch(pre + 'products/' + p.handle + '?section_id=bwx-mkt').then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h) { var m = h.match(/data-q="(-?\d+)"/); return !m || parseInt(m[1], 10) > 0 ? p : null; })
          .catch(function () { return p; });
      })).then(function (r) { return r.filter(Boolean); });
    }).then(function (list) {
      if (!list.length) return;
      var row = el.querySelector('[data-bwx-cw-row]'), seen = {};
      list.forEach(function (p) {
        if (seen[p.handle]) return; seen[p.handle] = 1;
        var a = document.createElement('a');
        a.className = 'bwx-cw__sw'; a.href = cleanUrl(p.url); a.title = colourOf(p.title);
        var src = p.image || (p.featured_image && p.featured_image.url);
        if (src) { var i = document.createElement('img'); i.src = img(src); i.alt = colourOf(p.title); i.loading = 'eager'; i.width = 80; i.height = 80; a.appendChild(i); }
        row.appendChild(a);
      });
      var n = row.children.length;
      if (n > 5) {
        Array.prototype.forEach.call(row.children, function (c, i) { if (i >= 4) c.classList.add('is-extra'); });
        var m = document.createElement('button'); m.type = 'button'; m.className = 'bwx-cw__sw bwx-cw__more';
        m.textContent = '+' + (n - 4); m.setAttribute('aria-label', '+' + (n - 4) + ' ' + el.getAttribute('data-t-cols'));
        m.addEventListener('click', function () { row.classList.add('is-all'); m.remove(); });
        row.appendChild(m);
      } else { row.classList.add('is-all'); }
      el.querySelector('[data-bwx-cw-n]').textContent = '· ' + n + ' ' + el.getAttribute('data-t-cols');
      el.hidden = false;
    });
  }
  function boot() { document.querySelectorAll('[data-bwx-cw]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
